export const ACCOUNT_PROFILES = [
  {
    name: "freeCodeCamp.org",
    userName: "@freeCodeCamp",
    photo: require("../assets/profilePicture/freeCodeCamp.png"),
    text: "We're a community of millions of people who are building new skills and getting new jobs toghether. A 501(c)(3) public charity. Tweets by @abbeyrenn",
    followers: "Node.js and 9 others follow",
  },
  {
    name: "TypeScript",
    userName: "@typescript",
    photo: require("../assets/profilePicture/typeScript.png"),
    text: "TypeScript is a language for application-scale JavaScript development. It's a typed superset of JavaScript that compiles to plain JavaScript",
    followers: "Node.js and 5 others follow",
  },
  {
    name: "Tailwind CSS",
    userName: "@tailwindcss",
    photo: require("../assets/profilePicture/tailwind.png"),
    text: "The utility-first CSS framework. Rapidly build modern websites, without ever leaving your HTML.",
    followers: "Yazeed Obaid and 3 others follow",
  },
];


